














































































import { mapMutations, mapState } from 'vuex';
import Axios from 'axios';
import {Component, Vue} from "vue-property-decorator";
import {Getter, Mutation, State, Action} from "vuex-class";
import AdminPageInfo from "@/components/AdminPageInfo.vue";
import alzuhudLink from "@/components/Functions/Functions";

  @Component({
    components: {
      AdminPageInfo,
    }
  })
  export default class Transactions extends Vue {
    @Getter token: any;
    @State adminUser: any;
    @Action snackIt: Function;
    @State routes: any[];
    panelTitle: string = '';
    tableLoading: boolean = true;
    pagesCount: number = 1;
    page: number = 1;
    headers: any = [
    ];
    packages = [];
   @Mutation replaceRoute: Function;
   @Mutation setBookingId: Function;
   @State language: any;

    getColor (status: any) {
        switch (status) {
            case "pending" :
                return 'orange';
            case "not paid" :
                return 'red';
            case "paid" :
                return 'green';
            case "removed" :
                return 'grey';
        }
    }
    async mounted () {
        this.replaceRoute(['Transactions']);
        this.$parent.$emit('update route');
        this.panelTitle = 'Transactions';


        this.headers = this.language === 'ar' ? (this.adminUser.toLowerCase() === 'user' ? [
            { text: 'العنوان', value: 'title' },
            { text: 'القيمة', value: 'amount' },
            { text: 'التاريخ', value: 'date' },
            { text: 'الحالة', value: 'status', align: 'left' },
            { text: 'OP', value: 'action', sortable: false, align: 'right' }
        ]: [
            {text: 'المستخدم', align: 'left', sortable: false, value: 'name'},
            { text: 'العنوان', value: 'title' },
            { text: 'القيمة', value: 'amount' },
            { text: 'التاريخ', value: 'date' },
            { text: 'الحالة', value: 'status', align: 'left' },
            { text: 'OP', value: 'action', sortable: false, align: 'right' }
        ]): (this.adminUser.toLowerCase() === 'user' ? [
          { text: 'Title', value: 'title' },
          { text: 'Amount', value: 'amount' },
          { text: 'Date', value: 'date' },
          { text: 'Status', value: 'status', align: 'left' },
          { text: 'OP', value: 'action', sortable: false, align: 'right' }
        ]: [
          {text: 'User', align: 'left', sortable: false, value: 'name'},
          { text: 'Title', value: 'title' },
          { text: 'Amount', value: 'amount' },
          { text: 'Date', value: 'date' },
          { text: 'Status', value: 'status', align: 'left' },
          { text: 'OP', value: 'action', sortable: false, align: 'right' }
        ]);

      try {
        const items = await Axios.get(`http://${alzuhudLink}:8080/api/transactions/all`, {
          params: {
            token: this.token,
          }
        });

        this.pagesCount = items.data.res.last_page;
          this.packages = items.data.res.data.map((item: any) => ({
          name: item.user_id.full_name,
          title: item.title,
          amount: '$' + this.split(item.amount),
          status: item.status,
          bookingId: item.booking_id.id,
          date: new Date(item.created_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
        }));


      } catch(e) {
        this.snackIt({
          message: this.adminUser.toLowerCase() === 'user' ? 'An Error Occurred while Getting Transactions' : 'An error occurred while getting users data ',
          color: 'error',
          snackbar: true
        });
      } finally {
        this.tableLoading = false;
      }
    }

    async changePage(e: any) {
      if (e !== undefined) {
        this.packages = [];
        this.tableLoading = true;
        try {
          const items = await Axios.get(`http://${alzuhudLink}:8080/api/transactions/all`, {
            params: {
              token: this.token,
              page: e,
            }
          });

          this.packages = items.data.res.data.map((item: any) => ({
            name: item.user_id.full_name,
            title: item.title,
            amount: '$' + this.split(item.amount),
            status: item.status,
            bookingId: item.booking_id.id,
            date: new Date(item.created_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }),
          }));
        } catch(e) {
          this.snackIt({
            message: this.adminUser.toLowerCase() === 'user' ? 'An error occurred while getting transactions' : 'An error occurred while getting users data ',
            color: 'error',
            snackbar: true
          });
        } finally {
          this.tableLoading = false;
        }
      }
    }
      split(str: string): string {
          let strData = parseFloat(str);
          let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          return data.split('.')[0];
      }

      view (id: number) {
          console.log("id is: ", id);
          this.setBookingId(id);
          this.$router.push('viewBooking');
      }
  }
